export default __webpack_public_path__ + "static/media/7.db0a8c69.png";